import { Injectable } from '@angular/core';
import { Equipment } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { ApprovalAndEquipment } from 'app/main/approvals-equipments/services/api/approvals-equipments-api.service';
import { EquipmentsAttachmentsApi } from './api/equipments-attachments.api';
import { EquipmentsApi } from './api/equipments.api';

interface EquipmentPageResult {
  items: Equipment[];
  totalCount: number;
  filtered: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EquipmentsService {
  constructor(
    private api: EquipmentsApi,
    private attachmentsApi: EquipmentsAttachmentsApi,
    private fuseProgressBarService: FuseProgressBarService
  ) {}

  async loadData({ where, options }): Promise<EquipmentPageResult> {
    this.fuseProgressBarService.show();
    return this.api
      .listEquipments({
        orderBy: options.orderBy,
        limit: options.limit,
        offset: options.offset,
        where: where
      })
      .toPromise()
      .then((page) => {
        this.fuseProgressBarService.hide();
        const filtered = Boolean(
          !!where.segmentId_in ||
          !!where.name_contains ||
          !!where.locationId_in ||
          !!where.number_contains ||
          !!where.equipmentTypeId_in ||
          !!where.warrantyStatusIn ||
          !!where.warrantyStartDateLte ||
          !!where.warrantyEndDateGte ||
          where.archived !== false
        );

        return {
          items: page.items,
          totalCount: page.totalCount,
          filtered: filtered
        };
      });
  }

  async saveEquipment(id: string, equipmentInput: any): Promise<any> {
    if (id) {
      return this.api.updateEquipment(id, equipmentInput).toPromise();
    }

    return this.api.createEquipment(equipmentInput).toPromise();
  }

  async saveEquipmentAttachment(id: string, equipmentAttachmentInput: any): Promise<any> {
    if (id && equipmentAttachmentInput) {
      return this.attachmentsApi.updateEquipmentAttachment(id, equipmentAttachmentInput).toPromise();
    }

    if (id && !equipmentAttachmentInput) {
      return this.attachmentsApi.deleteEquipmentAttachment(id).toPromise();
    }

    return this.attachmentsApi.createEquipmentAttachment(equipmentAttachmentInput).toPromise();
  }

  getApprovalAndEquipment({ approvalId, equipmentQrCode }): Promise<ApprovalAndEquipment> {
    return this.api.getApprovalAndEquipment({
      approvalId,
      equipmentQrCode
    });
  }
}
